(function () {
  class WinController {
    constructor() {
      this._batcher = undefined;
      this._winlineAnimator = undefined;
      this._symbolAnimator = undefined;
      this._active = false;
      this._skipped = false;

      this._belowStake = ["winBelow"];

      this._smallWins = ["winLow"];

      this._medWins = ["winMed"];

      this._highWins = ["winHigh"];
    }

    initialise(json) {
      if (gdk.mustShowSlowWin()) {
        this._batcher = resourceManager.getSharedPlugin(json.batcher_slow);
      } else {
        this._batcher = resourceManager.getSharedPlugin(json.batcher_normal);
      }

      //this._batcher = resourceManager.getSharedPlugin(json.batcher_normal);

      this._symbolAnimator = json.symbolAnimator
        ? resourceManager.get(json.symbolAnimator)
        : undefined;
      this._winlineAnimator = json.winlineAnimator
        ? resourceManager.getSharedPlugin(json.winlineAnimator)
        : undefined;
    }

    startAnimations(
      winData,
      celebrationThreshold,
      slotMachine,
      completeCallback
    ) {
      let self = this;
      self._active = true;
      let canCelebrate = winData.totalLineWinnings > celebrationThreshold;
      let sequenceData = this._batcher.batch(winData, celebrationThreshold);
      this._skipped = false;

      let currentSequence = 0;
      let playNextSequence = function (i) {
        if (canCelebrate) {
          // hunters moon hack, only play symbol win soun don the all batch
          let bestSymbolWin = -1;
          if (currentSequence === 0) {
            for (let j = 0; j < sequenceData[i].length; ++j) {
              if (sequenceData[i][j].winId > bestSymbolWin) {
                bestSymbolWin = sequenceData[i][j].winId;
              }
            }
          } else {
            bestSymbolWin = 0;
          }

          // Play the win sound here based on win amount
          const winnings = winData.totalLineWinnings;
          const stake = gameController.getCurrentModeStake();
          if (winnings < stake * 3) {
            soundManager.play("winLow");
          } else if (winnings > stake * 5) {
            soundManager.play("winHigh");
          } else {
            soundManager.play("winMed");
          }
        }

        let linesToPlay = [];

        for (let j = 0; j < sequenceData[i].length; ++j) {
          linesToPlay.push(sequenceData[i][j].winline);
        }

        let uniqueArray = linesToPlay.filter(function (item, pos) {
          return linesToPlay.indexOf(item) == pos;
        });

        let winlines = [];
        for (let j = 0; j < uniqueArray.length; ++j) {
          winlines.push(winData.winningLines[uniqueArray[j]]);
        }

        self._winlineAnimator.playAnimations(
          winlines,
          sequenceData[i],
          slotMachine,
          function () {}
        );

        if (self._symbolAnimator) {
          self._symbolAnimator.animateSymbols(
            sequenceData[i],
            slotMachine,
            canCelebrate,
            false,
            function () {
              ++currentSequence;
              if (currentSequence >= sequenceData.length || self._skipped) {
                self._active = false;
                completeCallback();
              } else {
                if (self._skipped) {
                  self._active = false;
                  completeCallback();
                } else {
                  playNextSequence(currentSequence);
                }
              }
            },
            function () {}
          );
        }
      };
      playNextSequence(currentSequence);
    }

    playAllSymbolAnimations(
      winData,
      symbols,
      celebrationThreshold,
      slotMachine,
      completeCallback
    ) {
      let self = this;
      self._active = true;
      let canCelebrate = winData.totalLineWinnings > celebrationThreshold;
      let sequenceData = this._batcher.batch(winData, celebrationThreshold);
      this._skipped = false;

      if (canCelebrate) {
        // Play the win sound here based on win amount
        const winnings = winData.totalLineWinnings;
        const stake = gameController.getCurrentModeStake();
        if (winnings < stake * 3) {
          soundManager.play("winLow");
        } else if (winnings > stake * 5) {
          soundManager.play("winHigh");
        } else {
          soundManager.play("winMed");
        }
      }

      if (self._symbolAnimator) {
        self._symbolAnimator.animateSymbols(
          symbols,
          slotMachine,
          canCelebrate,
          false,
          function () {
            self._active = false;
            completeCallback();
          },
          function () {}
        );
      }

      self._winlineAnimator.playAnimations(
        winData.winningLines,
        symbols,
        slotMachine,
        function () {}
      );
    }

    playRandomSounds(list) {
      const soundIndex = Math.floor(Math.random() * list.length);
      soundManager.play(list[soundIndex]);
    }

    isActive() {
      return this._active;
    }

    skipAnimations() {
      if (this.isActive()) {
        this._skipped = true;
        this._symbolAnimator.skip();
        if (this._winlineAnimator) this._winlineAnimator.skipAnimation();
      }
    }
  }

  let createWinController = function () {
    return new WinController();
  };

  resourceManager.registerController(
    "WinControllerAllAtOnce",
    createWinController
  );
})();
